export const AUDIT_EVENT_TYPE = {
  SelectedProductForIllustration: 'SelectedProductForIllustration',
  UpdatingProductIllustration: 'UpdatingProductIllustration',
  ChangingProductForIllustration: 'ChangingProductForIllustration',
  EmailSentToBorrower: 'EmailSentToBorrower',
  PdfDownloaded: 'PdfDownloaded',
  IllustratorSessionStarted: 'IllustratorSessionStarted',
  IllustratorSessionEnded: 'IllustratorSessionEnded',
  UpdatingProductDetailsForIllustration: 'UpdatingProductDetailsForIllustration',
  UpdatingWidgetCalculation: 'UpdatingWidgetCalculation',
};
